<template>
  <div>
    <v-divider class="my-5" />
    <label-icon label="Oligoelementos" icon="bubble_chart" bold />
    <div v-if="hasOligoelements">
      <v-list two-line>
        <v-list-group
          v-for="(diagnoseElement, index) in diagnoseOligoelements"
          :key="index"
          class="elevation-1"
        >
          <template v-slot:activator>
            <v-list-item class="pa-7">
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">
                  {{ diagnoseElement.oligoelement.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <div class="pa-3 black--text">
            <property-value
              property="Tipo"
              :value="diagnoseElement.oligoelement.type.name"
            />
            <property-value
              v-show="!!diagnoseElement.oligoelement.dailyIntake"
              property="Ingestão diária"
              :value="diagnoseElement.oligoelement.dailyIntake"
            />
            <property-value
              property="Informação"
              :value="diagnoseElement.oligoelement.information"
            />
            <select-items-editor
              :value="diagnoseElement.sources"
              :items="diagnoseElement.oligoelement.sources"
              return-value="sources"
              label="Fontes alimentares selecionadas"
              :rules="[$rules.arrayNotEmpty]"
              field-name="name"
              class="mb-3"
              @save="changeProperties"
              @open="selectIndex(index)"
            />
            <text-editor
              :value="diagnoseElement.therapistComments"
              label="Comentários aos terapeutas"
              return-value="therapistComments"
              class="mb-3"
              @save="changeProperties"
              @open="selectIndex(index)"
            />
            <switch-editor
              :value="diagnoseElement.hidePatient"
              label="Esconder ao paciente na diagnose"
              return-value="hidePatient"
              class="mb-3"
              @save="changeProperties"
              @open="selectIndex(index)"
            />
            <switch-editor
              :value="diagnoseElement.patientImpactAtHome"
              label="Recomendar ao paciente impactar em casa"
              return-value="patientImpactAtHome"
              class="mb-3"
              @save="changeProperties"
              @open="selectIndex(index)"
            />
            <text-editor
              :value="diagnoseElement.patientComments"
              label="Comentários ao paciente"
              return-value="patientComments"
              class="mb-3"
              @save="changeProperties"
              @open="selectIndex(index)"
            />

            <v-row justify="center" class="py-5">
              <v-btn dark color="red" @click="removeOligoelement(index)">
                <v-icon class="mr-2">delete</v-icon>
                Remover Oligoelemento
              </v-btn>
            </v-row>
          </div>
        </v-list-group>
      </v-list>
    </div>
    <div v-else class="mt-5">Nenhum oligoelemento adicionado.</div>
  </div>
</template>

<script>
export default {
  name: "OligoelementsSection",
  data: () => ({
    selectedIndex: -1,
  }),
  computed: {
    hasOligoelements() {
      return this.$store.getters["diagnosis/hasOligoelements"];
    },
    diagnoseOligoelements() {
      return this.$store.state.diagnosis.diagnose.oligoelements;
    },
  },
  methods: {
    changeProperties(property) {
      this.$store.commit("diagnosis/changePropertyOligoelements", {
        index: this.selectedIndex,
        property,
      });
    },
    selectIndex(index) {
      this.selectedIndex = index;
    },
    removeOligoelement(index) {
      this.$store.commit("diagnosis/removeOligoelement", index);
    },
  },
};
</script>

<style scoped></style>
